import React from "react";
import ImportDataAdmin from "../components/ImportDataAdmin";

export default function TeamImportPage() {
  return (
    <div className="max-w-5xl mx-auto px-6 py-10">
      <h1 className="text-3xl font-serif mb-4">Import d’œuvres pour un client</h1>
      <p className="text-gray-600 mb-6">
        Sélectionnez le fichier, mappez les colonnes, prévisualisez puis lancez l’import. 
        Le rattachement est effectué via l’email du collectionneur.
      </p>

      <ImportDataAdmin />

      <div className="mt-10 border-t pt-6">
        <h2 className="text-xl font-semibold mb-3">📘 Exemple concret</h2>
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm border">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-3 py-2 border">title</th>
                <th className="px-3 py-2 border">artist</th>
                <th className="px-3 py-2 border">year</th>
                <th className="px-3 py-2 border">medium</th>
                <th className="px-3 py-2 border">dimensions_height</th>
                <th className="px-3 py-2 border">dimensions_width</th>
                <th className="px-3 py-2 border">price_low</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="px-3 py-2 border">Composition n°5</td>
                <td className="px-3 py-2 border">Wassily Kandinsky</td>
                <td className="px-3 py-2 border">1923</td>
                <td className="px-3 py-2 border">Huile sur toile</td>
                <td className="px-3 py-2 border">90</td>
                <td className="px-3 py-2 border">120</td>
                <td className="px-3 py-2 border">450000</td>
              </tr>
              <tr>
                <td className="px-3 py-2 border">Sans titre</td>
                <td className="px-3 py-2 border">Pierre Soulages</td>
                <td className="px-3 py-2 border">1978</td>
                <td className="px-3 py-2 border">Peinture sur toile</td>
                <td className="px-3 py-2 border">150</td>
                <td className="px-3 py-2 border">100</td>
                <td className="px-3 py-2 border">300000</td>
              </tr>
            </tbody>
          </table>
        </div>

        <ul className="mt-4 space-y-2 text-sm text-gray-700">
          <li>➡️ Les colonnes inutiles peuvent être laissées vides.</li>
          <li>➡️ Les tags sont séparés par des virgules.</li>
          <li>📎 <a href="/artkiv_import_template.xlsx" className="text-blue-600 underline">
            Télécharger le modèle Excel (XLSX)
          </a></li>
        </ul>
      </div>
    </div>
  );
}
